import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { setShowGroupBooking } from '../../appSlice';
import { t } from '../../utilities/translator';

const GroupBookingBtn = ({ type, isLight = false, mt = false, isDesktopWizard = false }) => {
  const dispatch = useDispatch();
  const handleModal = () => dispatch(setShowGroupBooking(true));
  return (
    <div className={cn("gb-message flex flex-col gap-3", { 'gbm-light': isLight, 'mt-10': mt, 'gbm-dwiz': isDesktopWizard })}>
      <div className="gbm-txt">
        {type === 'room' ?
          t('groupBookingTutorial.multiRoomMessage') :
          t('groupBookingTutorial.capacityMessage')
        }
      </div>
      <div className="gbm-btn-wrap flex">
        {/* <span className="gbm-btn flex items-center gap-2 cursor-pointer" onClick={handleModal}>
          <i className="ri-team-line" />
          <span>{t('groupBookingTutorial.bookWithFriends')}</span>
        </span> */}
        <span className="gbm-btn2 cursor-pointer" onClick={handleModal}>
          {t('groupBookingTutorial.groupBooking')}
        </span>
      </div>
    </div>
  );
};

export default GroupBookingBtn;
